import React, { useState, useEffect } from 'react';
import { apiCall } from '../config';
import './AustinInventory.css';

const Toast = ({ message, type, onClose }) => (
  <div className={`toast ${type}`}> 
    {message}
    <button className="toast-close" onClick={onClose}>×</button>
  </div>
);

const AustinInventory = () => {
  const [skus, setSkus] = useState([]);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [toast, setToast] = useState({ message: '', type: '' });

  useEffect(() => {
    fetchSkus();
  }, []);

  useEffect(() => {
    if (toast.message) {
      const timer = setTimeout(() => setToast({ message: '', type: '' }), 4000);
      return () => clearTimeout(timer);
    }
  }, [toast]);

  const fetchSkus = async () => {
    setIsLoading(true);
    try {
      const response = await apiCall('/api/products', { method: 'GET' });
      if (response.ok) {
        const data = await response.json();
        setSkus(data);
        setRows(data.map(sku => ({
          IGD_SKU_number: sku.IGD_SKU_number,
          IGD_Name: sku.IGD_Name,
          IGD_Description: sku.IGD_Description,
          inventory_location: 'Austin',
          inventory_quantity: ''
        })));
      } else {
        setToast({ message: 'Failed to load SKUs', type: 'error' });
      }
    } catch (e) {
      setToast({ message: 'Error loading SKUs', type: 'error' });
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (index, field, value) => {
    setRows(rows => rows.map((row, i) => i === index ? { ...row, [field]: value } : row));
  };

  const handleSave = async () => {
    setIsLoading(true);
    let allSaved = true;
    let saveErrors = [];
    for (let row of rows) {
      if (row.inventory_quantity && !isNaN(row.inventory_quantity)) {
        const payload = {
          IGD_SKU_number: row.IGD_SKU_number,
          inventory_status: 'available',
          inventory_location: row.inventory_location,
          inventory_quantity: row.inventory_quantity
        };
        const response = await apiCall('/api/austin-inventory', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
        if (!response.ok) {
          allSaved = false;
          const errorData = await response.json();
          saveErrors.push(errorData.error || `Failed to save ${row.IGD_SKU_number}`);
        }
      }
    }
    if (allSaved) {
      setToast({ message: 'All inventory saved successfully!', type: 'success' });
    } else {
      setToast({ message: 'Some rows failed: ' + saveErrors.join('; '), type: 'error' });
    }
    setIsLoading(false);
  };

  return (
    <div className="austin-inventory">
      {toast.message && (
        <Toast message={toast.message} type={toast.type} onClose={() => setToast({ message: '', type: '' })} />
      )}
      <div className="page-header">
        <div className="header-content">
          <div className="header-title">
            <h1>Austin Inventory</h1>
          </div>
          <div className="header-tips">
            <ul>
              <li>Enter additional inventory for Austin location</li>
              <li>Only rows with a quantity will be saved</li>
            </ul>
          </div>
        </div>
        <div className="header-separator"></div>
      </div>
      <div className="page-content">
        <div className="section">
          <h2>Manual Inventory Entry</h2>
          {isLoading ? <div className="loading">Loading...</div> : (
            <div className="inventory-table">
              <table>
                <thead>
                  <tr>
                    <th>IGD_SKU_number</th>
                    <th>IGD_Name</th>
                    <th>IGD_Description</th>
                    <th>Location</th>
                    <th>Inventory Quantity</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((row, idx) => (
                    <tr key={row.IGD_SKU_number}>
                      <td>{row.IGD_SKU_number}</td>
                      <td>{row.IGD_Name}</td>
                      <td>{row.IGD_Description}</td>
                      <td>
                        <input
                          type="text"
                          value={row.inventory_location}
                          onChange={e => handleChange(idx, 'inventory_location', e.target.value)}
                          style={{ width: '90px' }}
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          step="any"
                          value={row.inventory_quantity}
                          onChange={e => handleChange(idx, 'inventory_quantity', e.target.value)}
                          style={{ width: '90px' }}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <button className="approve-button enabled" onClick={handleSave} disabled={isLoading} style={{ marginTop: 20 }}>
                {isLoading ? 'Saving...' : 'Save'}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AustinInventory; 